import { useEffect, useMemo, useState } from "react";
import useCheckQuestionsMinLength from "./useCheckQuestionsMinLength";
import moment from "moment";

const usePlayValidation = (
	title,
	description,
	period,
	addresses,
	questions
) => {
	const [playValidationSuccess, setPlayValidationSuccess] = useState(false);
	const [playValidationErrors, setPlayValidationErrors] = useState("");
	const countSelectedAddresses = useMemo(
		() => addresses?.filter(Boolean).length > 0,
		[addresses]
	);
	const checkedQuestions = useCheckQuestionsMinLength(questions);
	useEffect(() => {
		const errorTitle = "Нельзя запустить опрос: ";
		let errors = [];
		if (!title) {
			errors.push("нет заголовка");
		}
		if (!period) {
			errors.push("период не выбран");
		}
		if (!moment(period?.[1]).isAfter(moment(), "minute")) {
			errors.push("дата окончания опроса уже прошла");
		}
		if (!countSelectedAddresses) {
			errors.push("адреса не выбраны");
		}
		if (!checkedQuestions) {
			errors.push(
				"есть незаполненные поля вопросов или ответов, или есть вопрос с единственным вариантом ответа"
			);
		}
		const haveValidationErrors = errors.length !== 0;
		setPlayValidationSuccess(!haveValidationErrors);
		setPlayValidationErrors(
			!!errors.length ? errorTitle + errors.join(", ") + "." : null
		);
	}, [title, description, period, countSelectedAddresses, checkedQuestions]);
	return [playValidationSuccess, playValidationErrors];
};
export default usePlayValidation;
